import { render, staticRenderFns } from "./LoadingPadraoContainerMini.vue?vue&type=template&id=0f08eae1&scoped=true&"
import script from "./LoadingPadraoContainerMini.vue?vue&type=script&lang=js&"
export * from "./LoadingPadraoContainerMini.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPadraoContainerMini.vue?vue&type=style&index=0&id=0f08eae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f08eae1",
  null
  
)

export default component.exports